/** Usuario Simappe OAuth: parte del email antes de @ (conserva mayúsculas/minúsculas). */
export function deriveSimappeLoginUsername(emailOrUsername: string | undefined | null): string {
  const trimmed = (emailOrUsername ?? '').trim();
  if (!trimmed) return '';
  const at = trimmed.indexOf('@');
  return at > 0 ? trimmed.slice(0, at) : trimmed;
}

/** Correo con dominio tipo usuario@dominio.com (no cuentas técnicas tipo dev@datavault). */
export function isLikelyVaultLoginEmail(value: string | undefined | null): boolean {
  const trimmed = (value ?? '').trim();
  const at = trimmed.indexOf('@');
  if (at <= 0) return false;
  const domain = trimmed.slice(at + 1).trim();
  return domain.includes('.');
}

/** Usuario a persistir en el gestor del navegador tras login exitoso. */
export function resolveBrowserCredentialUsername(value: string | undefined | null): string {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return '';
  if (isLikelyVaultLoginEmail(trimmed)) {
    return deriveSimappeLoginUsername(trimmed);
  }
  return trimmed;
}

export function buildVaultUserLoginHint(email: string): string {
  return buildVaultUserLoginHintFromAccessUsername(deriveSimappeLoginUsername(email));
}

/** Hint de login con el `access_username` devuelto por el API (preferido). */
export function buildVaultUserLoginHintFromAccessUsername(
  accessUsername: string | undefined | null,
): string {
  const loginUser = (accessUsername ?? '').trim();
  if (!loginUser) return '';
  return `Para ingresar use: ${loginUser} y la contraseña asignada.`;
}

/** Usuario de acceso para UI: access_username del API o local-part del email. */
export function resolveAdminUserAccessUsername(
  user: { access_username?: string | null; email?: string | null },
): string {
  const fromApi = (user.access_username ?? '').trim();
  if (fromApi) return fromApi;
  return deriveSimappeLoginUsername(user.email);
}
